<template>
  <div>
    <PaymentMethodsModal
      v-if="selectedMethod"
      v-bind="{ selectedMethod, startDate, endDate }"
      @close="selectedMethodId = undefined"
      @show-tips="showTips"
    />
    <PosPaymentsModal
      v-if="showTipsModal"
      v-bind="{ startDate: tipsStartDate, endDate: tipsEndDate }"
      @close="showTipsModal = false"
    />
    <BaseCard :heading="$t('reports.totals.payment_methods')">
      <BaseTable
        v-if="paymentMethods.length"
        :rows="
          paymentMethods.map((method: any) => ({
            id: method.key,
            cells: [
              $t(`reports.totals.${method.key}`, brandNamePay()),
              {
                value: filters.currency(method.value),
                alignRight: true
              }
            ],
            clickable: method.key !== 'outstanding'
          }))
        "
        @select="onSelect($event)"
        printCompact
        v-test="'payment-methods'"
      />
    </BaseCard>
  </div>
</template>

<script
  setup
  lang="ts"
>
import filters from '@/filters';
import { brandNamePay } from '@/helpers/brand-name';
import PaymentMethodsModal from './PaymentMethodsModal.vue';
import PosPaymentsModal from './PosPaymentsModal.vue';
import type { PaymentMethod } from './types';

const props = defineProps<{
  paymentMethods: PaymentMethod[];
  startDate: string;
  endDate: string;
}>();

const selectedMethodId = ref<PaymentMethod['key']>();
const selectedMethod = computed(() =>
  selectedMethodId.value
    ? props.paymentMethods.find(
        (method) => method.key === selectedMethodId.value,
      )
    : undefined,
);

const showTipsModal = ref(false);
const tipsStartDate = ref('');
const tipsEndDate = ref('');

const onSelect = (key: PaymentMethod['key']) => {
  if (key === 'outstanding') {
    return;
  }

  selectedMethodId.value = key;
};

const showTips = (startDate: string, endDate: string) => {
  tipsStartDate.value = startDate;
  tipsEndDate.value = endDate;
  showTipsModal.value = true;
  selectedMethodId.value = undefined;
};
</script>
